(() => {
  if (customElements.get('vilora-size-guide')) return;
  const convert = value => {
    const clean = value.trim();
    if (!/^\d+(?:\.\d+)?(?:\s*[-–—]\s*\d+(?:\.\d+)?)?$/.test(clean)) return clean || '—';
    return clean.split(/\s*[-–—]\s*/).map(n => String(Math.round(Number(n) / 2.54 * 10) / 10)).join('–');
  };
  class ViloraSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.vsg__trigger');
      this.trigger.addEventListener('click', () => {
        if (this.previousOverflow === undefined) this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('.vsg__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.previousOverflow = undefined;
        this.trigger.focus({preventScroll:true});
      });
      this.querySelectorAll('[data-vsg-unit]').forEach(button => button.addEventListener('click', () => this.setUnit(button.dataset.vsgUnit)));
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
    setUnit(unit) {
      this.querySelectorAll('[data-vsg-cm]').forEach(cell => {
        cell.textContent = unit === 'in' ? convert(cell.dataset.vsgCm) : cell.dataset.vsgCm || '—';
      });
      this.querySelectorAll('[data-vsg-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vsgUnit === unit)));
      this.querySelectorAll('[data-vsg-unit-suffix]').forEach(label => label.textContent = unit === 'in' ? '(in)' : '(cm)');
      this.querySelector('[data-vsg-unit-label]').textContent = this.querySelector(unit === 'in' ? '[data-vsg-inches]' : '[data-vsg-centimetres]').textContent;
    }
  }
  customElements.define('vilora-size-guide', ViloraSizeGuide);
})();
